import { Grid, InputAdornment, Paper } from '@mui/material';
import {
  SahinButton,
  SahinTextField,
  SahinUIContext,
  ThemeMode,
} from '@sahinyazilim/sahinyazilim-components';
import { AdminTablePaths } from 'common/model/AdminTablePaths';
import { OwnerEnv } from 'common/utils/env';
import { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  CreateBrandData,
  CreateBrandFormResolver,
  subDomains,
} from './CreateBrand.types';
import { postAPI } from 'common/helper/apiHelpers';

export const CreateBrand = () => {
  const {
    register: formRegister,
    handleSubmit,
    formState,
    trigger,
  } = useForm<CreateBrandData>({
    resolver: CreateBrandFormResolver,
    mode: 'onChange',
  });
  const { t } = useTranslation();
  const { theme } = useContext(SahinUIContext);

  const [loading, setLoading] = useState(false);

  const subDomainRef = useRef<HTMLInputElement>(null);
  const domainRef = useRef<HTMLInputElement>(null);

  const onSubmit = (data: CreateBrandData) => {
    setLoading(true);
    postAPI(AdminTablePaths.BRAND, data)
      .then((res) => {
        if (res.status === 'success') {
          window.location.reload();
        }
      })
      .catch((item) => console.log(item))
      .finally(() => {
        setLoading(false);
      });
  };

  const nameChange = () => {
    const index = Math.floor(Math.random() * 10);
    [subDomainRef, domainRef].forEach((item) => {
      const input = item.current;
      if (!input) return;
      const name = subDomains[index % subDomains.length];
      input.placeholder = name;
    });
  };

  useEffect(() => {
    nameChange();

    const interval = setInterval(() => {
      nameChange();
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const register = (name: any) => {
    const registerData = formRegister(name);
    return {
      ...registerData,
      onChange: (e: any) => {
        trigger();
        registerData.onChange(e);
      },
    };
  };

  return (
    <Grid
      justifyContent="center"
      alignItems="center"
      direction="row"
      sx={{
        height: '100vh',
        background: 'linear-gradient(125deg, #764ba2 0%, #1789ef 50%)',
      }}
      container
    >
      <Grid
        onSubmit={handleSubmit(onSubmit)}
        xs={10}
        lg={4}
        component="form"
        alignContent="flex-start"
        item
        container
      >
        <Grid rowSpacing={3} px={3} pb={3} component={Paper} container>
          <Grid
            to="/"
            lg={12}
            mb={5}
            xs={12}
            justifyContent="center"
            component={Link}
            item
            container
          >
            <img
              src={
                theme === ThemeMode.DARK ? '/logo-white.png' : '/logo-black.png'
              }
              style={{ maxWidth: '100%', maxHeight: '40px' }}
              alt="MENU KOLAY"
            />
          </Grid>
          <Fragment key={3}>
            <Grid xs={12} item>
              <SahinTextField
                {...register('company')}
                autoComplete="organization"
                label={t('form.organizationName.value')}
                placeholder={t('form.organizationName.placeholder')}
                fullWidth
              />
            </Grid>
            <Grid xs={12} item>
              <SahinTextField
                // {...register('domain')}
                name="domain"
                label={t('form.customDomain.value')}
                placeholder={t('form.customDomain.placeholder')}
                helperText="Özel domain için özel pakete sahip olmalısınız"
                sx={{ opacity: 0.4 }}
                inputRef={domainRef}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">https://</InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">.com</InputAdornment>
                  ),
                }}
                disabled
                fullWidth
              />
            </Grid>
            <Grid xs={12} item>
              <SahinTextField
                {...register('subDomain')}
                label={t('form.subdomain.value')}
                placeholder={t('form.subdomain.placeholder')}
                helperText="Türkçe özel karakterler desteklenmez! (ö,ş,ı,ğ,ç,ü)"
                fullWidth
                inputRef={subDomainRef}
                onKeyUp={(e: any) => {
                  const value = e.target.value;
                  // Türkçe karakterleri İngilizce benzer karakterlere dönüştür ve küçük harfe çevir
                  const cleanedValue = value
                    .replace(/[öÖ]/g, 'o') // ö -> o
                    .replace(/[şŞ]/g, 's') // ş -> s
                    .replace(/[ıİ]/g, 'i') // ı -> i
                    .replace(/[ğĞ]/g, 'g') // ğ -> g
                    .replace(/[çÇ]/g, 'c') // ç -> c
                    .replace(/[üÜ]/g, 'u') // ü -> u
                    .toLowerCase(); // Büyük harfleri küçük harfe dönüştür

                  // Eğer değer değiştiyse input'u güncelle
                  if (value !== cleanedValue) {
                    e.target.value = cleanedValue;
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">https://</InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      .{OwnerEnv.domain}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Fragment>

          <Grid sx={{ mt: 5 }} justifyContent="end" container>
            <SahinButton
              key={1}
              variant="contained"
              type="submit"
              loading={loading}
              disabled={!formState.isValid}
            >
              OLUŞTUR
            </SahinButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
